module.exports = __webpack_public_path__ + "static/media/elevat.8eec5b0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/moho_blanco_papa/curativa/elevat.png
// module id = 1997
// module chunks = 3